import { BaseService } from "./BaseService";

export default {
  async realizarCadastro(formData) {
    const postData = JSON.stringify(formData);
    const response = await BaseService.fetchResponseFromAPIPost(
      `cadastrar/pessoa`,
      postData,
      "application/json",
    );

    return response;
  },

  async cadastrarPerfil(formData) {
    const postData = JSON.stringify(formData);
    const response = await BaseService.fetchResponseFromAPIPost(
      `perfil`,
      postData,
      "application/json",
    );

    return response;
  },
  async updatePerfil(formData) {
    const postData = JSON.stringify(formData);
    return await BaseService.fetchResponseFromAPIPost(
        `perfil/update/data`,
        postData,
        "application/json",
    );
  },

  async atribuirFuncionalidadePerfil(perfilid, formData) {
    const postData = JSON.stringify(formData);
    const response = await BaseService.fetchResponseFromAPIPost(
      `perfil/${perfilid}/funcionalidade`,
      postData,
      "application/json",
    );

    return response;
  },

  async removerFuncionalidadePerfil(perfilid, formData) {
    const postData = JSON.stringify(formData);
    const response = await BaseService.fetchResponseFromAPIDelete(
      `perfil/${perfilid}/funcionalidade`,
      postData,
    );

    return response;
  },
  async getMenu(hir) {
    return await BaseService.fetchResponseFromAPIGet(`menu/lista/${hir}`);

  },
  async obterHir(hir) {
    if(hir) {
      return await BaseService.fetchResponseFromAPIGet(`cargos_perfil/perfil/hir/${hir}`);
    } else {
      return await BaseService.fetchResponseFromAPIGet(`cargos_perfil/perfil/hir`);
    }


  },
  async getUserInfo() {
    const objectResponse = {
      item: {},
    };
    const data = await BaseService.fetchResponseFromAPIGet(`dados_pessoais`);
    objectResponse.item = await data.content;

    return objectResponse.item;
  },

  async getPerfilUser(){
    const response = await BaseService.fetchResponseFromAPIGet(`exibedadosusuario`);
    
    return response.content;
    
  },

  async getPerfilUserById(idSigrh){
    const response = await BaseService.fetchResponseFromAPIGet(`perfil/${idSigrh}`);
    
    return response.content;
    
  },

  async getFuncionaliadesByPerfilId(perfilid) {
    const objectResponse = {
      item: {},
    };
    const data = await BaseService.fetchResponseFromAPIGet(
      `funcionalidade/perfil/${perfilid}`,
    );
    objectResponse.item = await data.content;

    return objectResponse.item;
  },

  async getFuncionalidades() {
    const data = await BaseService.fetchResponseFromAPIGet(`funcionalidade`);
    const reponse = await data.content;

    return reponse;
  },

  async getMenus() {
    const data = await BaseService.fetchResponseFromAPIGet(`menu`);
    const reponse = await data.content;

    return reponse;
  },
  async getPerfisList() {
    const data = await BaseService.fetchResponseFromAPIGet(`perfil/list`);
    const reponse = await data.content;
    return reponse;
  },
  async getPerfis() {
    const data = await BaseService.fetchResponseFromAPIGet(`perfil/list`);
    const reponse = await data.content;
    return reponse;
  },
  async getPerfisSelect() {
    const data = await BaseService.fetchResponseFromAPIGet(`cargos_perfil/usuario`);
    const reponse = await data.content;
    return reponse;
  },

  async getUsersInternos(page, filters) {
   // let data;

    if (filters) {
      return await BaseService.fetchResponseFromAPIGet(
        `pessoas?page=${page}&${filters}`,
      );
    } else {
      return await BaseService.fetchResponseFromAPIGet(
        `pessoas?page=${page}`,
      );
    }


    //return reponse;
  },

  async excluirPerfil(perfilid) {
    const data = await BaseService.fetchResponseFromAPIDelete(
      `perfil/${perfilid}`,
    );

    return data;
  },

  async addPerfilUser(perfilid, userid) {
    const data = await BaseService.fetchResponseFromAPIPost(
      `perfil/${perfilid}/sigrh/${userid}`,
    );

    return data;
  },
  async showPerfil(perfilid) {
    return await BaseService.fetchResponseFromAPIGet(
      `perfil/view/${perfilid}`,
    );
  },

  async removePerfilUser(perfilid, userid) {
    const data = await BaseService.fetchResponseFromAPIDelete(
      `perfil/${perfilid}/sigrh/${userid}`,
    );

    return data;
  },

  async getFuncionalidadesAcessiveis() {
    const data = await BaseService.fetchResponseFromAPIGet(
      `funcionalidades_acessiveis`,
    );
    const reponse = await data.content;

    return reponse;
  },

  async editarUserInfo(userid, postData) {
    postData.append("_method", "PUT");
    const data = await BaseService.fetchResponseFromAPIPost(
      `dados_pessoais/${userid}`,
      postData,
    );

    return data;
  },

  async validaAssinatura(postData) {
    const data = await BaseService.fetchResponseFromAPIPost(
      `assinatura`,
      postData,
    );

    return data;
  },
};